import * as _ from "lodash";

////////////////////////
// Format values

const financeFormat = new Intl.NumberFormat( 'ru-RU', {
    useGrouping          : true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
} )

export function formatFinance( number ) {
    return financeFormat.format( number )
}

const integerFormat = new Intl.NumberFormat( 'ru-RU', {
    useGrouping          : true,
    maximumFractionDigits: 0,
} )

export function formatInteger( number ) {
    let result = integerFormat.format( number )

    if (result === 'не число') {
        console.warn('formatInteger', 'Входные данные не явлюятся числом')
        return '-'
    }

    return result
}

const collator = new Intl.Collator( 'ru-RU', {} )

export function compareStrings( a, b ) {
    return collator.compare( a, b )
}

export const formatByType = {
    'string' : value => value,
    'finance': value => formatFinance( value ),
    'integer': value => formatInteger( value ),
}

export const ColumnTypes = {
    integer: 'integer',
    finance: 'finance',
    string : 'string',
}

export function isNumberColumn(col) {
    return col.type === ColumnTypes.integer || col.type === ColumnTypes.finance
}

export function isStringColumn(col) {
    return col.type === ColumnTypes.string
}

// Format values
////////////////////////



///////////////////////
// Table_source columns

export function getColumnsForSourceTable(data) {
    const sourceIconMap = {
        'Google Maps': 'https://static.repometr.com/images/sources/1.svg',
        'Яндекс': 'https://static.repometr.com/images/sources/3.svg',
        '2GIS': 'https://static.repometr.com/images/sources/19.svg',
    }

    const flat = data.reduce((acc, item) => {
        const sources = item.sources.reduce((acc, source) => {
            const obj = { // TODO Будет создаваться много объектов. Можно оптимизировать.
                name: source.name,
                type: ColumnTypes.integer,
                isAscSort: true,
                isSort: false,
                infoIcon: true,
                isClickable: true,
            }
            obj.sourceIconUrl = sourceIconMap[obj.name]
            acc.push(obj)
            return acc
        }, [])

        return acc.concat(sources)
    }, [])

    return _.uniqBy(flat, 'name')
}


export const columnsNameToTypeMap = {
    name: ColumnTypes.string,
    frequency: ColumnTypes.integer,
    position: ColumnTypes.integer,
}

export function makeSourceDataForTable_keywordGroup(list, branchId = null) {
    const map = list.map(entity => {
        // console.log(`entity.id: ${entity.id}, branchId: ${branchId}`);
        return entity.sources.reduce((acc, source) => {
            acc[source.name] = {...source, branchId, keywordId: entity.id}
            return acc
        }, {})
    })

    // console.dir(list)
    // console.dir(map)
    return map
}

export function makeSourceDataForTable_branchGroup(list, keywordId = null) {
    const map = list.map(entity => {
        console.log(`entity.id: ${entity.id}, keywordId: ${keywordId}`);
        return entity.sources.reduce((acc, source) => {
            acc[source.name] = {...source, branchId: entity.id, keywordId}
            return acc
        }, {})
    })
    return map
}

// Table_source columns
///////////////////////

export function sortByString(data, key, asc = true) {
    data.sort((a, b) => {
        return asc
            ? compareStrings(b[key], a[key])
            : compareStrings(a[key], b[key])
    })
}

export function sortObjectsByNumber(data, key, asc = true) { // TODO Не сортирует по вложенному значению
    data.sort((a, b) => {
        return asc
            ? getValueByPath(a, key) - getValueByPath(b, key)
            : getValueByPath(b, key) - getValueByPath(a, key)

        function getValueByPath(obj, path) {
            const props = path.split('.')
            return props.reduce( (acc, key) => {
                return acc[key]
            }, obj)
        }
    })
}

// export function sortObjectsBy__dev(data, key, asc = true) {
//     data.sort((a, b) => {
//         return asc
//             ? getValueByPath(a, key) - getValueByPath(b, key)
//             : getValueByPath(b, key) - getValueByPath(a, key)
//
//         function getValueByPath(obj, path) {
//             const props = path.split('.')
//             return props.reduce( (acc, key) => {
//                 return acc[key]
//             }, obj)
//         }
//     })
// }



export const localPackLogger = Logger()

function Logger() {
    const devMode = true

    return {
        log
    }

    function log(...args) {
        if (devMode) {
            console.log(...args)
        }
    }
}



export function checkConditions(conditions) {
    const chek = conditions.every(cond => cond !== null && cond !== undefined)
    if (!chek)  {
        console.warn('conditions is null or undefined')
    }
    else {
        return chek
    }
}



export function prettyJson(value) {
    try {
        return JSON.stringify(value, null, 2);
    }
    catch(error) {
        console.warn(error)
        return 'Ошибка парсинга json';
    }
}


function howMuchSourcesInResponseList(list) {
    let maxLength = 1

    list.forEach(item => {
        const length = item.sources.length
        if (length > maxLength) {
            maxLength = length
        }
    })

    return maxLength
}

export function sourceColumnsCountStyle(count) {
    let styleString = ''

    while(count > 0) {
        styleString += '1fr '
        count--
    }

    return styleString
}


/**
 * Получить из другой таблицы строку, соответсвующую индексу списка
 * Применяется в сдвоенных таблицах
 */
export function getAccordingTableRowData(data, index) {
    return data[index]
}